import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

/**
 * Returns whether the Factor meal summary card should be shown on the in-session
 * Session Prep tab. Gated by the `show-meal-summary-on-prep` GrowthBook flag.
 *
 * When this returns false, the card is neither rendered nor does its data
 * request fire (the underlying query stays disabled).
 */
export const useShowMealSummaryOnPrep = (): boolean => {
  return useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.SHOW_MEAL_SUMMARY_ON_PREP);
};
